// import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { setQueryParams, getQueryParam } from 'Util/Url';
import { fetchQuery } from 'Util/Request';
import BlogPostsQuery from '../../../query/BlogPosts.query';

import Magazine from './Magazine.component';

class MagazineContainer extends PureComponent {
    static propTypes = {
        // TODO: implement prop-types
    };

    state = {
        active_tab : 0,
        publish_sort_options : [],
        selectedYear : '',
        isLoading : false
    }

    componentDidMount() {
        this.requestDropDownValues();
    }

    requestDropDownValues(){
        const { category_id    } = this.props;
        let options = category_id ? { filter: { category_id: { eq: category_id } } }  : {};
        options.pageSize = 300;
        options.currentPage = 1;
        return fetchQuery(BlogPostsQuery.getQuery(options)).then((data) => {
            const { posts } = data;
            if(Object.keys(posts).length){
                const { items } = posts;
                let yearArray = [];
                items.map(
                    item => {
                        yearArray.push(item.publish_time.split('-')[0])
                    }
                );
                function onlyUnique(value, index, self) {
                    return self.indexOf(value) === index;
                }
                let yearArrayUnique = yearArray.filter(onlyUnique);
                let publish_sort_options = [];
                yearArrayUnique.map(value=> publish_sort_options.push({value, label: value}))
                if(publish_sort_options.length){
                    this.setState({
                        publish_sort_options,
                        selectedYear : yearArrayUnique.sort().reverse()[0].split('-')[0],
                        selectedYearCount : yearArrayUnique.reduce((initial,x) => {
                            initial[x] = yearArray.filter(y => y===x).length;
                            return initial;
                        }, {})
                    });
                }
            }
        });
    }


    requestAllPages(){
        const { selectedYear } = this.state;
        const { requestPosts, category_id    } = this.props;
        let options = category_id ? { filter: { category_id: { eq: category_id } } }  : {};
        options.pageSize = 300;
        options.currentPage = 1;

        if(selectedYear){
            if(!options.filter)
                options.filter = {};
            options.filter.publish_time = {
                    gteq : selectedYear+"-01-01 00:00:00",
                    lteq : (parseInt(selectedYear) + 1)+"-01-01 00:00:00"

            };
        }
        this.setState({ isLoading : true})
        let self = this;
        setTimeout(
            ()=> {
                requestPosts(options);
                self.setState({ isLoading : false})
            },
            1000
        );
    }

    containerFunctions = {
        changeTab : this.changeTab.bind(this),
        onDropDownChange : this.onDropDownChange.bind(this)
    };

    onDropDownChange(value){
        const { requestPosts, category_id } = this.props;
        this.setState({selectedYear : value, isLoading : true});
        let option = {
            pageSize : 300,
            filter :
                {
                    publish_time : {
                        gteq : value+"-01-01 00:00:00",
                        lteq : (parseInt(value) + 1)+"-01-01 00:00:00"
                }
            }
        };
        if(category_id)
            option.filter.category_id = { eq: category_id };
        setTimeout(()=> { this.setState({ isLoading : false}) }
        ,1000);
        requestPosts(option)
    }

    containerProps = () => {
        const { active_tab, publish_sort_options, selectedYear, isLoading,selectedYearCount } = this.state;

        return { active_tab, publish_sort_options, selectedYear, isLoading, selectedYearCount }
    };

    changeTab(index){
        const { requestPosts, location,history, category_id } = this.props;
        this.setState({
            active_tab : index
        })
        if(index === 1){
            setQueryParams({
                page: ''
            }, location,history);
            this.requestAllPages();
        }else {
            const options = category_id ? { filter: { category_id: { eq: category_id } } }  : {};
            requestPosts({...options, currentPage : this._getPageFromUrl()})
        }

    }

    _getPageFromUrl() {
        const { location } = this.props;
        return +(getQueryParam('page', location) || 1);
    }

    render() {
        return (
            <Magazine
                { ...this.props }
              { ...this.containerFunctions }
              { ...this.containerProps() }
            />
        );
    }
}

export default MagazineContainer;
